import AccessPointModal from 'components/Checkout/Shared/AccessPointButton/AccessPointModal//AccessPointModal';
import { withAccessPointModalProps } from 'viewModel/checkout/shared/accessPointButton/accessPointModal/withAccessPointModalProps';

export default withAccessPointModalProps(AccessPointModal);
